// removed by extract-text-webpack-plugin
module.exports = {"next":"_3Wmt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/next/index.less
// module id = 257
// module chunks = 0